export default __webpack_public_path__ + "static/media/bee.0ab53bc7.jpg";